// src/App.js
import { useEffect, useRef } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useKeycloak } from "@react-keycloak/web";

import Homepage from "./pages/Homepage";
import HomepageAlt from "./pages/HomepageΑlt";
import Layout from "./layout/Layout";
import MapPage from './pages/MapPage';
import DataInsertionPageCombined from './pages/dataInsert';
import OldFlex from './pages/OldFlex';
import NotFound from './pages/NotFound';
import ForecastsPage from './pages/dashboard/ForecastsPage';
import DataAnalyticsPage from './pages/dashboard/DataAnalyticsPage';
import UnifiedDashboard from './pages/dashboard/UnifiedDashboard';
import DashboardRedirect from './pages/dashboard/DashboardRedirect';
import ProfilePage from './pages/ProfilePage';
import ErrorBoundary from './components/ErrorBoundary';

// Remove DashboardLayout import

// Get primary and secondary colors from CSS
let primary = getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim();
let secondary = getComputedStyle(document.documentElement).getPropertyValue('--secondary-color').trim();

// Define your theme
const theme = createTheme({
    palette: {
        primary: { main: primary },
        secondary: { main: secondary },
    },
    typography: {
        fontFamily: ['Poppins', 'Segoe UI', 'Roboto', 'Jura'].join(','),
    }
});

function App() {
    const { keycloak, initialized } = useKeycloak();
    const navigate = useNavigate();
    const location = useLocation();
    const wasAuthenticatedRef = useRef(false);

    useEffect(() => {
        if (initialized) {
            // Check if user just logged in (went from unauthenticated to authenticated)
            if (keycloak.authenticated && !wasAuthenticatedRef.current) {
                // User just logged in, navigate to homepage
                navigate('/', { replace: true });
            }

            // Update the ref to track current authentication state
            wasAuthenticatedRef.current = keycloak.authenticated;
        }
    }, [initialized, keycloak.authenticated, navigate]);

    if (!initialized) {
        return <div>Loading...</div>;
    }

    return (
        <ErrorBoundary>
            <ThemeProvider theme={theme}>
                <Routes>
                    {/* All routes use the Base Layout */}
                    <Route element={<Layout />}>
                        <Route path="/" element={<Homepage />} />
                        <Route path="/alt" element={<HomepageAlt />} />
                        <Route path="/map" element={<MapPage />} />
                        <Route path='/dataInsert' element={<DataInsertionPageCombined />} />
                        <Route path="/oldFlex" element={<OldFlex />} />
                        <Route path="/profile" element={<ProfilePage />} />

                        {/* New Unified Dashboard Routes */}
                        <Route path="/dashboard/:method/:section" element={<UnifiedDashboard />} />
                        <Route path="/dashboard/:method" element={<UnifiedDashboard />} />
                        <Route path="/dashboard" element={<DashboardRedirect />} />

                        {/* Legacy Dashboard Routes - keep for backward compatibility */}
                        <Route path="/dashboard/legacy/analytics" element={<DataAnalyticsPage />} />
                        <Route path="/dashboard/legacy/forecasts" element={<ForecastsPage />} />
                        {/* Add other routes here */}
                    </Route>

                    <Route path="*" element={<NotFound />} />
                </Routes>
            </ThemeProvider>
        </ErrorBoundary>
    );
}

export default App;
